import { DE$ } from '@infl-ts/util-datum';
import { CssBaseline } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { constant, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import ThemeProvider from './theme-provider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SetupTheme = function SetupTheme(_ref) {
  var siteConfig = _ref.siteConfig,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(ThemeProvider, {
    themeConfig: pipe(siteConfig, DE.map(function (c) {
      return c.configs.themeConfig;
    })),
    modes: pipe(siteConfig, DE.map(function (c) {
      return c.configs.appConfig;
    }), DE.map(O.match(constant([]), function (_ref2) {
      var modes = _ref2.modes;
      return modes;
    })), DE$.getSuccessOrElse([])),
    "data-element": "ThemeProvider",
    "data-component": "SetupTheme",
    "data-source-file": "setup-theme.tsx",
    children: [/*#__PURE__*/_jsx(CssBaseline, {
      "data-element": "CssBaseline",
      "data-component": "SetupTheme",
      "data-source-file": "setup-theme.tsx"
    }), children]
  });
};